module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/3@2x_d1ad669613910f4e0e1b3fa97725b339.png";